import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';

interface GlobalContextType {
    inverted: boolean;
    setInverted: React.Dispatch<React.SetStateAction<boolean>>;
    token: null|string;
    setToken: React.Dispatch<React.SetStateAction<null|string>>;
    username: string;
    setUserName: React.Dispatch<React.SetStateAction<string>>;
    is_admin: boolean;
    setIs_admin: React.Dispatch<React.SetStateAction<boolean>>;
}

// Создаем контекст с начальным значением
const GlobalContext = createContext<GlobalContextType>({
    inverted: false,
    setInverted: () => {},
    token: null,
    setToken: () => {},
    username: "",
    setUserName: () => {},
    is_admin: false,
    setIs_admin: () => {},
});

export const useGlobalContext = () => useContext(GlobalContext);

interface GlobalProviderProps {
    children: ReactNode;
}

export const GlobalProvider: React.FC<GlobalProviderProps> = ({ children }) => {
    const [inverted, setInverted] = useState<boolean>(localStorage.getItem('inverted') === 'true');
    const [token, setToken] = useState<null|string>(localStorage.getItem('token'));
    const [username, setUserName] = useState<string>(localStorage.getItem('username') ?? '');
    const [is_admin, setIs_admin] = useState<boolean>(localStorage.getItem('is_admin') === 'true');


    useEffect(() => {
        localStorage.setItem('inverted', inverted ? 'true' : 'false');
    }, [inverted]);

    useEffect(() => {
        localStorage.setItem('is_admin', is_admin ? 'true' : 'false');
    }, [is_admin]);

    useEffect(() => {
        localStorage.setItem('username', username);
    }, [username]);

    useEffect(() => {
        if (token)
            localStorage.setItem('token', token);
        else
            localStorage.removeItem('token');
    }, [token]);

    return (
        <GlobalContext.Provider value={{ inverted, setInverted, token, setToken, username, setUserName, is_admin, setIs_admin }}>
            {children}
        </GlobalContext.Provider>
    );
};
